import type { PrizeFulfilment } from '@/types'
import { mapToDateTime } from '@/utils/date-time-utils'

import type ApiClient from '../lib/ApiClient'
import type {
  PrizeClaimCashAlternativeRequest,
  PrizeClaimCashAlternativeResponse,
  PrizeClaimPhysicalRequest,
  PrizeClaimPhysicalResponse,
  PrizeFulfilmentResponse,
} from '../lib/ApiClient.types'

export default class PrizeFulfilmentService {
  constructor(private apiClient: ApiClient) {}

  async getPrizes(): Promise<PrizeFulfilment[]> {
    return this.prizeFromDto(
      await this.apiClient.get<PrizeFulfilmentResponse>('/prize-fulfilments', {
        auth: true,
      })
    )
  }

  /**
   *
   * @param fulfilmentId
   * @param address
   * @returns
   */
  async claimPhysicalPrize(
    fulfilmentId: string,
    address: PrizeClaimPhysicalRequest['address']
  ) {
    return this.apiClient.post<
      PrizeClaimPhysicalResponse,
      PrizeClaimPhysicalRequest
    >(
      `/prize-fulfilments/${fulfilmentId}/claim`,
      {
        type: 'prize',
        address,
      },
      { auth: true }
    )
  }

  async claimCashAlternative(fulfilmentId: string) {
    return this.apiClient.post<
      PrizeClaimCashAlternativeResponse,
      PrizeClaimCashAlternativeRequest
    >(
      `/prize-fulfilments/${fulfilmentId}/claim`,
      {
        type: 'cash_alt',
      },
      { auth: true }
    )
  }

  private prizeFromDto(dto: PrizeFulfilmentResponse): PrizeFulfilment[] {
    return mapToDateTime(dto.items).map(
      (prize) =>
        ({
          ...prize,
          id: prize.id.toString(),
          prize: {
            card_image: {
              src: prize.image.url,
            },
          },
        }) as PrizeFulfilment
    )
  }
}
